import {
  SUBMIT_SCORE_LOADING,
  SUBMIT_SCORE_ERROR,
  SUBMIT_SCORE_SUCCESS,
  CLEAR_SUBMIT_SCORE
} from "../../../constant/actionTypes";

const initialState = {
  loading: false,
  data: {},
  status: {},
};

const submitScoreReducer = (state = initialState, action) => {
  switch (action.type) {
    case SUBMIT_SCORE_LOADING: {
      let obj = { loading: true };
      return obj;
    }
    case SUBMIT_SCORE_SUCCESS: {
      let obj = { loading: false, data: action.response };
      return obj;
    }
    case SUBMIT_SCORE_ERROR: {
      let obj = { loading: false, status: action.response };
      return obj;
    }
    case CLEAR_SUBMIT_SCORE: {
      let obj = { loading: false, data: {}, status: {} };
      return obj;
    }
    default:
      return state;
  }
};

export default submitScoreReducer;
